module.exports = __webpack_public_path__ + "img/middle.b545e948.svg";